export var TicketPriceRestriction;
(function(TicketPriceRestriction) {
    TicketPriceRestriction[/**
     * A Vista Loyalty membership is required (see [[Member]]).
     */ "Member"] = "Member";
    TicketPriceRestriction[/**
     * A [[ThirdPartyMemberCard]] belonging to the specified [[ThirdPartyMemberTicketPrice.thirdPartyMemberSchemeId]] is required.
     */ "ThirdPartyMemberCard"] = "ThirdPartyMemberCard";
    TicketPriceRestriction[/**
     * Redemption of a voucher belonging to one of the specified [[VoucherTicketPrice.voucherTypeCodes]] is required.
     */ "Voucher"] = "Voucher";
    TicketPriceRestriction[/**
     * Redemption of a [[MemberReward]] with the specified [[MemberRewardTicketPrice.rewardId]] is required.
     */ "MemberReward"] = "MemberReward";
    TicketPriceRestriction[/**
     * A [[MemberSubscriptionCard]] belonging to the specified [[MemberSubscriptionTicketPrice.subscriptionId]] is required.
     */ "MemberSubscriptionCard"] = "MemberSubscriptionCard";
    TicketPriceRestriction[/**
     * Redemption of a [[Discount]] with the specified [[TicketPrice.discountId]] is required.
     */ "Discount"] = "Discount";
})(TicketPriceRestriction || (TicketPriceRestriction = {}));

//# sourceMappingURL=ticket-price-restriction.js.map